import styled from 'styled-components';
import { device } from 'theme';

export const TopNavBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: 56px;
  background: ${(props) => props.$backgroundColor || '#ff3366'};
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 16px;
  z-index: 1000;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.3);

  @media ${device.tablet} {
    padding: 0 24px;
  }
`;

export const LeftNavContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-start;
  grid-column: 1;
`;

export const TournamentLink = styled.a`
  color: #ffffff;
  font-size: 14px;
  font-weight: 600;
  text-decoration: none;
  transition: opacity 0.2s ease;
  white-space: nowrap;

  &:hover {
    opacity: 0.85;
  }

  &:active {
    opacity: 0.7;
  }

  @media ${device.tablet} {
    font-size: 16px;
  }
`;

export const HighlightText = styled.span`
  background: rgba(255, 255, 255, 0.2);
  padding: 2px 6px;
  border-radius: 4px;
`;

export const MobileOnlyText = styled.span`
  display: inline;

  @media ${device.tablet} {
    display: none;
  }
`;

export const DesktopOnlyText = styled.span`
  display: none;

  @media ${device.tablet} {
    display: inline;
  }
`;

export const SiteNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  transition: opacity 0.2s ease;
  justify-content: center;
  grid-column: 2;

  &:hover {
    opacity: 0.85;
  }

  &:active {
    opacity: 0.7;
  }
`;

export const SiteIcon = styled.img`
  width: 28px;
  height: 28px;
  object-fit: contain;
  border-radius: 4px;

  @media ${device.tablet} {
    width: 32px;
    height: 32px;
  }
`;

export const SiteName = styled.h1`
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  margin: 0;
  text-align: center;
  text-transform: capitalize;
  letter-spacing: 0.5px;

  @media ${device.tablet} {
    font-size: 20px;
  }
`;

export const NavIconsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  justify-content: flex-end;
  grid-column: 3;
`;
